export default __webpack_public_path__ + "static/media/whisky.f0590614.png";